import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthRefreshTokenPayload } from './auth-refresh-token.model';

@Injectable()
export abstract class AbstractRefreshTokenAdaptor {
  abstract onRefreshToken(payload: AuthRefreshTokenPayload): Observable<AuthRefreshTokenPayload>;
  abstract onRefreshTokenFail(payload: AuthRefreshTokenPayload, error: unknown): void;
}
